export class SecurityElement {
  public DisplayName: string;
  public EnumName: string;
  public Element: number;
  public ElementType: number;

  public constructor() {
    this.DisplayName = '';
    this.EnumName = '';
    this.Element = 0;
    this.ElementType = 1;
  }
}
